import { render, staticRenderFns } from "./ProfileEditAvatar.vue?vue&type=template&id=13eccbe8&scoped=true"
import script from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditAvatar.vue?vue&type=style&index=0&id=13eccbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eccbe8",
  null
  
)

export default component.exports